import { IPlatformPageSection } from '@/shared/types/platform-pages';
import Image from 'next/image';

interface IProps {
  content: IPlatformPageSection;
}

const SingleImageSection = ({ content }: IProps) => {
  return (
    <div className="section-inner image">
      {content?.imageTitle && <h3 className="image-title">{content?.imageTitle}</h3>}
      <Image
        src={content.image}
        style={content?.imageStyle ? content.imageStyle : null}
        alt={content.title}
        width={575}
        height={575}
        sizes="(min-width: 1024px) 575px, (min-width: 768px) 460px, (min-width: 640px) 387px, calc(100vw -32px)"
        loading="lazy"
      />
    </div>
  );
};

export default SingleImageSection;
